<template>
  <div :class="!_isMobile ? 'mt88' : 'warpMt'">
    <contactusPc v-if="!_isMobile" :inviteList="inviteList"></contactusPc>
    <contactusMobile v-else :inviteList = inviteList></contactusMobile>
  </div>
</template>

<script>
  import contactusPc from './pc/contactusPc.vue'
  import contactusMobile from './mobile/contactusMobile.vue'
  export default {
     metaInfo(){
      return {
        meta:[
          {
            name: 'title',
            content: '优加健保健康科技 ( 北京 ) 有限公司'
          },
          {
            name:'keywords',
            content:'优加健康,优加健保健康科技 ( 北京 ) 有限公司,医疗保险,创新医疗险,技术团队'
          },
          {
            name: 'description',
            content: '优加健康 一支既懂医疗又懂保险的专业化团队 针对创新医疗险的产品/服务创新和落地能力,服务覆盖百万人群。 针对商保的医疗式专家型管理服务团队,行业权威协会和专业院校共同培训及认证。 精通健康险及互联网数据运营的产品及技术团队。'
          }
        ]
      }
    },
    data() {
      return {
        _isMobile: false,
        inviteList: [{
          title: 'B端高级产品经理',
          major:'',
          address: '北京',
          desc: '<p>1、结合公司发展战略，全面策划及统筹B端产品的发展规划，明确定位、目标、策略并推动落地；</p><p>2、用户思维佳，注重用户体验；</p><p>3、负责产品详细设计，UI、UE，确保用户体验整体设计质量；</p><p>4、制定产品项目计划，跟进产品的研发，协调各方资源确保项目按时按质完成；</p><p>5、与其他部门积极配合，跟踪产品运营及业务发展状况，充分应用数据挖掘及分析进行产品运营效益评估，推动产品业绩增长。</p>',
          desc1:'<p>1、6年以上互联网医疗或互联网保险行业产品经验；主持或主要参与过大型互联网产品的建设，熟悉互联网或软件产品整体实施过程，包括从需求分析到产品运营全流程。</p><p>2、对医疗行业、保险行业市场具有敏锐洞察力，持续关注互联网领域，具有创新意识；</p><p>3、良好的跨部门沟通能力和团队协作能力；具备良好的职业操守，对工作质量负责，能够承受工作压力及应对挑战；</p><p>4、熟练掌握Visio、Axure RP、x-mind及相关办公软件。</p>',
          isShow: false
        },
        {
          title:'解决方案产品经理',
          major:'',
          address:'北京',
          desc:'<p>1.负责项目前期的售前支持—包括市场需求调研、方案讲解，方案编写等；</p><p>2.定期收集和汇总市场、业务发展趋势，为公司产品研发、市场拓展提供相关规划；</p><p>3.与项目经理配合支持重点项目上线，并萃取提炼行业合作案例、内部分享培训赋能，支持营销部门完成项目推广；</p><p>4.新项目评估—配合产研、运营等团队评估方案落地性，制定完整解决方案；</p><p>5.与市场团队配合提炼产品方案亮点。</p>',
          desc1:'<p>1、本科学历以上，医疗、保险专业优先，具备医疗、保险工作经验的不限专业；</p><p>2、1-3年的医疗、保险行业工作经验，了解保险公司、TPA市场优先，有售前支持工作经验优先；</p><p>3、具有健康服务方案、医疗产品设计、医疗产品运营、输出高质量PPT、规范文档等、售前支持等工作经验；</p><p>4、认可创业公司文化、有意在医疗产品&健康险领域发展、有自驱力与责任感。</p>',
          isShow: false
        },
        {
          title:'重客项目经理',
          major:'',
          address:'北京、上海',
          desc:'<p>1、负责公司重点客户项目的业务开拓，包括商务洽谈、深度合作机会挖掘、合作方案整理及项目落地推动，为所对接重客项目的销售额负责；</p><p>2、推动公司重点客户项目的深度建设与产出，包括本地健康服务生态体系搭建、保险+健康服务的创新业务模式的探索与落地等；</p><p>3、负责重点客户新合作服务项目的管理与推动。</p>',
          desc1:'<p>1、本科及以上，5年以上营销及大客户项目经验优先；</p><p>2、有保险公司、互联网医疗、健康管理公司工作经验者；</p><p>3、具备独立拓展客户、跟进项目落地的能力，有商务+产品+项目管理复合经验者优先；</p><p>4、自驱力强。</p>',
          isShow: false
        },
        {
          title:'商务经理/\高级商务经理/\商务总监',
          major:'',
          address:'北京、上海、广州、深圳',
          desc:'<p>1、负责完成所负责区域/分公司销售目标，达成销售回款任务；</p><p>2、负责客户拓展及维护，包括保司及企业客户渠道拓展，了解客户需求，促成销售达成；</p><p>3、熟悉健康管理市场及保险行业情况，及时更新市场信息和竞争对手信息；</p><p>4、参与产品开发及定制，独立完成与保司、专业中介机构等客户产品上线的全流程商务谈判及对接落地；</p><p>5、搭建属地化医疗健康网络；</p><p>6、负责团队搭建、管理及工作指导；</p><p>7、完成上级领导交办的其他工作。</p>',
          desc1:'<p>1、本科及以上学历；</p><p>2、5年及以上保险行业、互联网健管行业企业客户渠道商务或大客户销售工作经验；</p><p>3、具备区域/分公司负责人、销售渠道团队管理经验；</p><p>4、自驱力强，靠谱皮实，精益求精、学习力强，有创业者精神。</p>',
          isShow: false
        }]
      }
    },
    components: {
      contactusPc,
      contactusMobile,
    },
    created() {
      this._isMobile = this.$util._isMobile()
    },
  }
</script>

<style lang="less" scoped>
  .madeMobile {
    height: 5.4rem;
  }

  .madePc {
    height: 600px;
  }

  img {
    width: 100%;
    height: 100%;
  }
  .mt88 {
    margin-top: 88px;
  }
  .warpMt{
    margin-top: 1.55rem;
  }
</style>


// WEBPACK FOOTER //
// src/views/contactus.vue